<style scoped>
.small-map{
    width: 200px;
    height: 150px;
    border: 1px solid gray;
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: #fff;
    z-index: 9999;
}
.restoreMap{
  position: absolute;
  left: 5px;
  font-size: 18px;
}
.restoreMap:hover{
  color: #f1966f;
  cursor: pointer;
}
.icon-legend{
  width: 80%;
  margin: 0 auto;
  border-top: solid 1px #515a6e;
  padding: 5px 10px;
  background: white;
  color: #17233d;
}
.tipBox {
  float: right;
  padding: 5px 10px;
  line-height: 22px;
}
.tipBox a {
  width: 50px;
  height: 10px;
  display: block;
  border: 1px solid #ccc;
  float: left;
  margin: 5px 5px;
  cursor: auto;
}
</style>
<style lang="less">
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
}
</style>

<template>
    <Modal v-model="modalGraphSvg" width='1400' footer-hide class-name="vertical-center-modal">
        <p class="text-center">
          <strong class="text-16">检索可用资源：</strong>
          <DatePicker v-model="searchSchedule" @on-change="handleChangeSchedule" type="daterange" placement="bottom-end" placeholder="请选择查询档期" style="width: 200px"></DatePicker>
        </p>
        <div>
            <Tabs v-if="svgList.length>0" v-model="defaultTab" @on-click="changeTabs" :animated="false">
              <TabPane v-for="(item, index) in svgList" :key="index" :label="stationTabLables[index]" :name="'tab'+index">
                <ul style="list-style-type:none;">
                    <li class="tipBox"><a href="javascrip:void(0);" style="background-color:#B6B6B7"></a>不可用</li>
                    <li class="tipBox"><a href="javascrip:void(0);" style="background-color:#FFEB3A"></a>已售出</li>
                    <li class="tipBox"><a href="javascrip:void(0);" style="background-color:#008100"></a>可售卖</li>
                </ul>
              </TabPane>
            </Tabs>

            <div v-html="reviewSvgHtml" name="svgStationHtml" style="height:600px" class="svg-station-content" id="svg-station-content"></div>
            <Row class="icon-legend">
              <i-col span="2"><h3>图例：</h3></i-col>
              <i-col span="22">
                <Row>
                  <i-col span="3" v-for="(icon,index) in buttonIcons" :key="index">
                    <p>{{icon.title}}</p>
                    <svg v-html="icon.svg" style="height:20px"></svg>
                  </i-col>
                </Row>
              </i-col>
            </Row>
        </div>
    </Modal>
</template>

<script>
import svgPanZoom from 'svg-pan-zoom'
import { GetDateStr, ParseDate } from '@/utils/dataformat'
import { getIcon } from '@/api/station'
import { getSoldResourceInfo } from '@/api/order'

export default {
  data () {
    return {
      svgList: [],
      stationTabLables: [],
      defaultTab: 'tab0',
      reviewSvgHtml: '',

      modalGraphSvg: false,
      modalGraphSvgTitle: '',
      searchSchedule: [],

      reviewSmallSvgHtml: '',
      reallyMaster: false, // 已经存在了小地图，那么不再重新加载该地图
      buttonIcons: [],
      buttonIconsSizeLarge: [1, 2, 4, 5, 6, 68, 72, 77, 79, 80, 81, 87, 88],
      buttonIconsSizeSmall: [78]
    }
  },
  created () {
    this.searchSchedule = [GetDateStr(new Date(), 1), GetDateStr(new Date(), 30)]
  },
  methods: {
    beginReviewSvg (stationSvgs, title) {
      this.modalGraphSvgTitle = title
      this.modalGraphSvg = true
      this.svgList = stationSvgs
      this.loadIcons()

      if (this.svgList.length > 0) {
        this.defaultTab = 'tab0'
        this.reviewSvgHtml = this.svgList[0].svg
        this.formatSvg()
        this.handleChangeSchedule()

        this.stationTabLables = []
        let label
        for (let index = 0; index < this.svgList.length; index++) {
          label = (this.svgList[index].floor > 0) ? '地上' : '地下'
          label += this.svgList[index].floor + '层' + this.svgList[index].positionName
          this.stationTabLables.push(label)
        }
      }
    },
    changeTabs () {
      const svgIndex = parseInt(this.defaultTab.substr(3))
      this.reviewSvgHtml = this.svgList[svgIndex].svg
      this.formatSvg()
      this.tagResource(this.currentSoldResource)
    },
    formatSvg () {
      this.$nextTick(() => {
        const currentSvgElement = document.getElementById('svg-station-content').firstElementChild
        // 设置svg呈现在画板上的尺寸
        currentSvgElement.setAttribute('width', '100%')
        currentSvgElement.setAttribute('height', '100%')

        var curMap = svgPanZoom(currentSvgElement, {
          panEnabled: true,
          controlIconsEnabled: false,
          zoomEnabled: true,
          dblClickZoomEnabled: true
        })

        if (currentSvgElement.id === '') {
          curMap.zoom(1.8)
          this.addMapMouseEvent(currentSvgElement)
        }
      })
    },
    addMapMouseEvent (svgElement) { // 添加普通地图的事件
      const svgChidrenElement = svgElement.lastElementChild.lastElementChild.children

      if (svgChidrenElement) {
        // 移除title标签， 改标签用于tips
        if (svgChidrenElement[0].nodeName === 'title') {
          svgChidrenElement[0].parentNode.removeChild(svgChidrenElement[0])
        }

        for (let index = 0; index < svgChidrenElement.length; index++) {
          if (svgChidrenElement[index].nodeName === 'g' && svgChidrenElement[index].hasAttribute('data-id')) {
            // 为媒体元素添加鼠标事件
            const curElement = svgChidrenElement[index]
            const xOffset = 15
            const yOffset = 15
            // curElement.setAttribute('cursor', 'pointer')

            curElement.addEventListener('mouseover', (e) => {
              for (let i = 0; i < curElement.children.length; i++) {
                if (curElement.children[i].nodeName !== 'text' && curElement.children[i].hasAttribute('stroke') && curElement.children[i].getAttribute('stroke') !== 'null') {
                  curElement.children[i].setAttribute('stroke', '#19be6b')
                }
              }

              var divTemp = document.createElement('div')
              var nodes = null
              // 文档片段，一次性append，提高性能
              var fragment = document.createDocumentFragment()
              divTemp.innerHTML = "<div id='screenshot'><p>" + curElement.getAttribute('data-devicemodel') + '</p><p>' + curElement.getAttribute('data-devicecode') + '</p></div>'
              nodes = divTemp.childNodes
              for (var i = 0, length = nodes.length; i < length; i += 1) {
                fragment.appendChild(nodes[i].cloneNode(true))
              }
              svgElement.parentNode.appendChild(fragment)
              // 据说下面这样子世界会更清净
              nodes = null
              fragment = null

              document.getElementById('screenshot').style.top = (e.offsetY + yOffset) + 'px'
              document.getElementById('screenshot').style.left = (e.offsetX + xOffset) + 'px'
            })
            curElement.addEventListener('mouseout', (e) => {
              for (let j = 0; j < curElement.children.length; j++) {
                if (curElement.children[j].nodeName !== 'text' && curElement.children[j].hasAttribute('stroke') && curElement.children[j].getAttribute('stroke') !== 'null') {
                  curElement.children[j].setAttribute('stroke', '#000000')
                }
              }

              document.getElementById('screenshot').parentNode.removeChild(document.getElementById('screenshot'))
            })
            curElement.addEventListener('mousemove', (e) => {
              document.getElementById('screenshot').style.top = (e.offsetY + yOffset) + 'px'
              document.getElementById('screenshot').style.left = (e.offsetX + xOffset) + 'px'
            })
          }
        }
      }
    },
    loadIcons () {
      getIcon().then(res => {
        this.buttonIcons = res.map((item) => {
          let svgHtml = item.svg
          if (this.buttonIconsSizeLarge.includes(item.id)) {
            svgHtml = svgHtml.replace('<g>', '<g transform="scale(1.5)">')
          } else if (this.buttonIconsSizeSmall.includes(item.id)) {
            svgHtml = svgHtml.replace('<g>', '<g transform="scale(0.7)">')
          }

          return {
            title: item.title,
            svg: svgHtml
          }
        })
      })
    },
    handleChangeSchedule () {
      if (this.searchSchedule[0] === '') {
        // 清空数据，还原绿色
        this.tagResource([])
      } else {
        // 检索出已售出的资源， 并标注黄色
        let postData = {
          schedules: JSON.stringify([{ startDate: ParseDate(this.searchSchedule[0]), endDate: ParseDate(this.searchSchedule[0]) }]),
          stationIds: this.svgList[0].stationId
        }
        getSoldResourceInfo(postData).then(res => {
          this.tagResource(res)
        })
      }
    },
    tagResource (resourceBeanList) {
      this.currentSoldResource = resourceBeanList
      this.$nextTick(() => {
        const pathNodeList = document.getElementById('svg-station-content').getElementsByTagName('path')
        const gNodeList = document.getElementById('svg-station-content').getElementsByTagName('g')
        const deviceIds = resourceBeanList.map(x => x.deviceId)

        if (pathNodeList.length > 0) {
          for (let i = 0; i < pathNodeList.length; i++) {
            const el = pathNodeList[i]

            if (el.hasAttribute('data-id')) {
            // 判断灯箱点位是否包含在清单中
              const deviceId = parseInt(el.getAttribute('data-id'))
              if (deviceIds.indexOf(deviceId) > -1) {
                el.setAttribute('fill', '#FFEB3A')
                el.setAttribute('cursor', 'auto')
                // 移除掉事件
                el.removeEventListener('click', (e) => {
                  this.$emit('on-select', deviceId)
                })
              } else { // 还原绿色
                el.setAttribute('fill', '#008100')
                el.setAttribute('cursor', 'pointer')
                // 注册点击事件，并调用父组件方法
                el.addEventListener('click', (e) => {
                  this.$emit('on-select', deviceId)
                })
              }
            }
          }
        }

        // 新版地图使用g
        if (gNodeList.length > 0) {
          for (let j = 0; j < gNodeList.length; j++) {
            const newEl = gNodeList[j]

            if (newEl.hasAttribute('data-id')) {
              // 判断灯箱点位是否包含在清单中
              const deviceId = parseInt(newEl.getAttribute('data-id'))
              if (deviceIds.indexOf(deviceId) > -1) {
                newEl.setAttribute('fill', '#FFEB3A') // 黄色
                const gChild = newEl.children
                for (let k = 0; k < gChild.length; k++) {
                  gChild[k].setAttribute('fill', '#FFEB3A') // 黄色
                }
                newEl.setAttribute('cursor', 'auto')
                // 移除掉事件
                newEl.removeEventListener('click', (e) => {
                  this.$emit('on-select', deviceId)
                })
              } else {
                newEl.setAttribute('fill', '#008100') // 绿色可用
                const gChild = newEl.children
                for (let k = 0; k < gChild.length; k++) {
                  gChild[k].setAttribute('fill', '#008100') // 绿色可用
                }
                newEl.setAttribute('cursor', 'pointer')
                // 注册点击事件，并调用父组件方法
                newEl.addEventListener('click', (e) => {
                  this.$emit('on-select', deviceId)
                })
              }
            }
          }
        }
      })
    }
  }
}

</script>
